export const REPLACED_ITEM_LIST_ID = 'replacement_products';
export const REPLACED_ITEM_LIST_NAME = 'Replacement products';

export const UNAVAILABLE_ITEM_LIST_ID = 'unavailable_products';
export const UNAVAILABLE_ITEM_LIST_NAME = 'Unavailable Products';
